import { dataTable } from "@iewc/Utilities/styleguide/DataTable";
import { colorStrings } from "@iewc/Utilities/variables";
import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const globalStyle: RecursivePartial<InjectableCss<{}>> = {
    css: css`
        .table__wrapper {
            overflow-x: auto;
            width: 100%;
        }

        table {
            &:not([class*="DataTableStyle"]) {
                ${dataTable.defaultProps?.css}

                th {
                    background: ${getColor(colorStrings.commonAccent)};
                    border-bottom: 2px solid ${getColor(colorStrings.commonBorder)};
                }

                th,
                td {
                    box-sizing: border-box;
                    height: 50px;
                    padding: 0 12px;
                    border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
                    white-space: nowrap;
                }

                td {
                    border-left-color: transparent;
                    border-right-color: transparent;
                }
            }
        }
    `,
};
